import { render } from "./FavouritesIcon.vue?vue&type=template&id=1ee45217&scoped=true"
import script from "./FavouritesIcon.vue?vue&type=script&lang=js"
export * from "./FavouritesIcon.vue?vue&type=script&lang=js"

import "./FavouritesIcon.vue?vue&type=style&index=0&id=1ee45217&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee45217"]])

export default __exports__